module.exports = __webpack_public_path__ + "e316a955b4067fea540f3cc85c488952.svg";